import { addMinutes, format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

const modeType = (mode) => {
    switch (mode.toLowerCase()) {
        case 'charge':
            return "充電";
        case 'discharge':
            return "放電";
        case 'auto':
            return "自動";
        case 'standby':
            return "待機";
        default:
            return "---";
    }
}

const statusType = (status) => {
    switch (status.toLowerCase()) {
        case 'in_progress':
            return "送信中";
        case 'completed':
            return "成功";
        case 'failed':
            return "失敗";
        case 'canceled':
            return "キャンセル";
        case 'scheduled':
            return "予定";
        default:
            return "送信中";
    }
}

const is30MinutesFromNow = (time) => {
    const now = new Date();
    // Convert the current time to the 'Asia/Tokyo' timezone
    const tokyoTime = utcToZonedTime(now, 'Asia/Tokyo');
    // Add 30 minutes to the current time
    const futureTime = addMinutes(tokyoTime, 30);
    // Format the time to the 'HH:mm' format
    const formattedTime = format(futureTime, 'HH:mm');
    // Compare the formatted time with the user inputted time
    return formattedTime <= time;
}

export { modeType, statusType, is30MinutesFromNow }